import moment from 'moment';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardFooter, CardHeader, Row, Col, CardBody } from 'reactstrap';
import CountryFlag from 'common/countryFlag';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import getShippingLineLinkUrl from 'helpers/shipping_line_url';
import countryFlag from 'common/countryFlag';
import { taskBadges } from 'constants/layout';

const BookingList = props => {
	return (
		<Col xl="6" key={props.index}>
			<ul className="verti-timeline list-unstyled mt-4">
				<li className={`event-list active`}>
					<div className="event-timeline-dot">
						<i className={`font-size-18 bx bxs-right-arrow-circle bx-fade-right`} />
					</div>
					<div className="flex-shrink-0 d-flex">
						<div className="me-3">
							<h5 className="font-size-13">
								<Link to={`/booking-details/${props.item.bookingNumber}`} className="text-dark">
									{props.item.bookingNumber}
								</Link>
								{/* <br/>
                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" /> */}
							</h5>

							{props.item?.bookingDetails?.bookingLine != '' ? (
								<span className="font-size-11 mb-2 text-center">
									{getShippingLineLinkUrl(props.item?.bookingDetails?.bookingLine, props.item.bookingNumber)}
								</span>
							) : null}
							{props.item?.bookingDetails?.customerReferenceNumber &&
							props.item?.bookingDetails?.customerReferenceNumber != '' ? (
								<div className="font-size-12 mt-2 mb-1">{props.item?.bookingDetails.customerReferenceNumber}</div>
							) : (
								<></>
							)}
							<div className="mt-1">
								<div className="font-size-12">
									{' '}
									<i className="fas fa-boxes" style={{ marginRight: '2px' }} />(
									{props.item?.bookingDetails?.bookingContainer})
								</div>
							</div>
						</div>
						<div className="flex-grow-1">
							<div className="font-size-11">
								{props.item?.bookingDetails?.loadingLocation != '' ? (
									<>
										{props.item?.bookingDetails?.loadingLocation}
										<i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle " />
									</>
								) : null}
								{props.item?.bookingDetails?.polLocation}{' '}
								{countryFlag[props.item?.bookingDetails?.polCountry.toLowerCase()]}
								<i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle " />
								{props.item?.bookingDetails?.podLocation}{' '}
								{countryFlag[props.item?.bookingDetails?.podCountry.toLowerCase()]}
							</div>

							<div className="mt-2 font-size-11">
								{props.item?.taskDetails?.taskText} {' : '}
								{props.item?.taskDetails?.taskDates}
							</div>

							<div className="mt-2">
								<span className="font-size-11 ">
									{props.item?.taskDetails?.taskName == 'Loading Status' ? 'Loading Status' : 'Status'} :{' '}
								</span>
								{props.item?.taskDetails?.taskStatus && (
									<span
										className={`badge badge-sm ms-2  ${
											{
												...taskBadges
											}[props.item?.taskDetails?.taskStatus]
										}`}
									>
										{props.item?.taskDetails?.taskStatus}
									</span>
								)}
							</div>
						</div>
					</div>
				</li>
			</ul>
		</Col>
	);
};

export default BookingList;
